var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobalerisErrorUnauthorized({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 200",
    fill: "none",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 96,
    r: 63,
    strokeOpacity: 0.13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 36 164 53v36c0 31-18 51-44 65-26-14-44-34-44-65V53l44-17Z",
    fill: "currentColor",
    fillOpacity: 0.035
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 36 164 53v36c0 31-18 51-44 65-26-14-44-34-44-65V53l44-17Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 81,
    width: 38,
    height: 31,
    rx: 5,
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 81,
    width: 38,
    height: 31,
    rx: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109 81V70a11 11 0 0 1 22 0v11"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 95,
    r: 2.5,
    fill: "currentColor",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 98v5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 91,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 183,
    cy: 119,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53 145h12m-6-6v12M177 48h10m-5-5v10",
    strokeOpacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalerisErrorUnauthorized);
export default __webpack_public_path__ + "static/media/globaleris-error-unauthorized.b4948743.svg";
export { ForwardRef as ReactComponent };